import { render, staticRenderFns } from "./send-message.vue?vue&type=template&id=e8b6f504&"
import script from "./send-message.vue?vue&type=script&lang=js&"
export * from "./send-message.vue?vue&type=script&lang=js&"
import style0 from "./send-message.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports